import { SeatPreferenceSelectionInput } from '@eti/schema-types';
import { seatingPreferenceOptions } from '../constants/seatingPreferenceOptions';
import { seatingPreferenceValues } from '../constants/seatingPreferenceValues';
export const getSeatingPreferenceOptions = type => {
  const SeatingComboOptions = {
    seatingPreferenceOptions: [{
      id: 'SeatingPreference_id_option_1',
      label: 'Product.SeatMap.Segment.Unavailable.SeatingLight.AisleSeat',
      value: SeatPreferenceSelectionInput.Aisle
    }, {
      id: 'SeatingPreference_id_option_2',
      label: 'Product.SeatMap.Segment.Unavailable.SeatingLight.WindowSeat',
      value: SeatPreferenceSelectionInput.Window
    }, {
      id: 'SeatingPreference_id_option_3',
      label: 'Product.SeatMap.Segment.Unavailable.SeatingLight.AnySeat',
      value: seatingPreferenceValues.RANDOM
    }],
    seatingBesideOptions: [{
      id: 'SeatingBeside_id_option_1',
      label: 'Product.SeatMap.Segment.Unavailable.SeatingBeside.TryToSeatUsTogether',
      value: SeatPreferenceSelectionInput.Beside
    }, {
      id: 'SeatingBeside_id_option_2',
      label: 'Product.SeatMap.Segment.Unavailable.SeatingBeside.RequestAnySeatAvailable',
      value: seatingPreferenceValues.RANDOM
    }]
  };
  if (type === seatingPreferenceOptions.SELL_SEATING_PREFERENCE) {
    return SeatingComboOptions.seatingPreferenceOptions;
  }
  return SeatingComboOptions.seatingBesideOptions;
};
//# sourceMappingURL=SeatingLightOrBeside.utils.js.map